/** 首屏 LCP：放 public，便于 HTML preload，且不进 JS 依赖图 */
const heroBanner1Bg = `${process.env.PUBLIC_URL || ""}/hero-lcp.webp`;

/** 轮播图推荐尺寸（PC / 手机通用） */
export const HERO_CAROUSEL_IMAGE_SIZE = {
  width: 1920,
  height: 800,
};

/**
 * 仅打包当前启用的轮播资源，避免未上线的大图进入首屏 JS 依赖图。
 * 恢复多图时：提高 HERO_CAROUSEL_ACTIVE_COUNT，并在此按需 import 对应资源。
 */
export const heroSlidesV1 = [
  {
    id: "banner-1",
    image: heroBanner1Bg,
    textInImage: false,
    variant: "factory-cert",
    titleKey: "heroBanner1Title",
    metricPrefixKey: "heroBanner1MetricPrefix",
    metricValue: "53000⁺",
    metricSuffixKey: "heroBanner1MetricSuffix",
    featureKeys: [
      "heroBanner1Feature1",
      "heroBanner1Feature2",
      "heroBanner1Feature3",
      "heroBanner1Feature4",
    ],
  },
];

export const HERO_CAROUSEL_ACTIVE_COUNT = 1;

export const heroSlidesActive = heroSlidesV1.slice(0, HERO_CAROUSEL_ACTIVE_COUNT);
